module.exports = __webpack_public_path__ + "img/ButtonTwo.0ccf4b42.svg";